import { ILancamento, ILancamentoPaged, ILancamentoPossivel } from "../interfaces/ILancamento";
import api from "./Api"

class LancamentoNovaService {
    async listar(
        esteiraId: number,
        cartaoId: number,
        tipo: string,
        offset: number = 0,
        perPage: number = 400
    ): Promise<ILancamento[]> {
        const { data } = await api.get<ILancamento[]>(`Lancamento/${esteiraId}/${cartaoId}/${tipo}`, {
            params: { offset, perPage }
        });
        return data;
    }

    async listarPendentes(
        esteiraId: number,
        cartaoId: number,
        page: number = 1,
        perPage: number = 20,
        tipoLancamento?: 'C' | 'D',
        filtro?: { ano?: number; mes?: number; dia?: number; historico?: string; valor?: number }
    ): Promise<ILancamentoPaged> {
        const { data } = await api.get<ILancamentoPaged>(`Lancamento/${esteiraId}/${cartaoId}/pendentes`, {
            params: {
                page,
                perPage,
                ...(tipoLancamento ? { tipoLancamento } : {}),
                ...(filtro?.ano ? { ano: filtro.ano } : {}),
                ...(filtro?.mes ? { mes: filtro.mes } : {}),
                ...(filtro?.dia ? { dia: filtro.dia } : {}),
                ...(filtro?.historico ? { historico: filtro.historico } : {}),
                ...(filtro?.valor !== undefined && !isNaN(filtro.valor) ? { valor: filtro.valor } : {}),
            }
        });
        return data;
    }

    async buscarPossivelMatch(id: number): Promise<ILancamentoPossivel[]> {
        const { data } = await api.get<ILancamentoPossivel[]>(`Lancamento/buscar-possivel-match/${id}`);
        return data;
    }


    async buscarLancamentosExtratoConciliado(esteiraID: number, conta: string): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/Lancamento/Extrato/Conciliado/${esteiraID}/${conta}`);

        return result;
    }

    async buscarLancamentosPendentes(esteiraID: number, conta: string): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/Lancamento/Extrato/Pendente/${esteiraID}/${conta}`);

        return result;
    }

    async gerarArquivoLancamentos(esteiraID: number, conta: string): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/Lancamento/Extrato/ArquivoPendente/${esteiraID}/${conta}`);

        return result;
    }


    async alterarConta(id: number, conta: string): Promise<any> {
        const { data: result } = await api.patch<any>(`v2/Lancamento/AlterarConta/${id}/${conta}`);
        return result;
    }


    async desvincularStatus(id: number): Promise<any> {
        const { data: result } = await api.patch<any>(`v2/Lancamento/DesvincularStatus/${id}`);
        return result;
    }


    async buscarPorId(id: number): Promise<any> {
        const { data } = await api.get(`Lancamento/${id}`);
        return data;
    }

    async buscarSomaAno(esteiraId: number, cartaoId: number): Promise<{ somaCreditos: number; somaDebitos: number }> {
        const { data } = await api.get(`Lancamento/soma-ano`, { params: { idEsteira: esteiraId, idCartao: cartaoId } });
        return data;
    }

    async buscarAge(esteiraId: number, cartaoId: number): Promise<{ totalGeral: number; faixas: { faixa: string; total: number }[] }> {
        const { data } = await api.get(`Lancamento/age`, { params: { idEsteira: esteiraId, idCartao: cartaoId } });
        return data;
    }

    async gerarArquivoPendentes(esteiraID: number, conta: string): Promise<any> {
        const { data: result } = await api.get<any>(`v2/Lancamento/Extrato/ArquivoLancamentos/${esteiraID}/${conta}`);

        return result;
    }
}


export default new LancamentoNovaService();